import { ENDPOINTS } from "../../constant/routes";
import { request } from "../../services/requests";

export interface AdminActionEntry {
  id: string;
  created_at: string;
  admin_user_id: string;
  admin_email: string | null;
  /** e.g. order.complete, order.manual_create, withdrawal.mark_paid, user.tariff */
  action: string;
  target_type: string | null;
  target_id: string | null;
  summary: string;
  details: Record<string, any>;
}

export interface ActivityResponse {
  /** false until the admin_actions migration has been applied */
  available: boolean;
  actions: AdminActionEntry[];
  /** Pass as `before` to load the next (older) page; null when there's no more */
  next_before: string | null;
}

export interface ActivityParams {
  limit?: number;
  before?: string;
  /** Exact action, or a prefix ending in "." (e.g. "order.") */
  action?: string;
  target_type?: string;
  target_id?: string;
  q?: string;
}

export const getActivity = (token: string, params: ActivityParams = {}) =>
  request(token).get<ActivityResponse>(ENDPOINTS.ACTIVITY, { params });

export interface BroadcastHistoryEntry {
  id: string;
  sent_at: string;
  sent_by: string | null;
  message: string | null;
  requested: number | null;
  sent: number | null;
  failed: number;
}

export const getBroadcastHistory = (token: string, limit = 20) =>
  request(token).get<{ available: boolean; broadcasts: BroadcastHistoryEntry[] }>(`${ENDPOINTS.NOTIFICATIONS}/history`, {
    params: { limit },
  });
